<template>
  <div class="pc_search">
    <div class="search-main">
      <div class="search-input">
        <el-input
          prefix-icon="el-icon-search"
          v-model="searchParams.keyword"
          :placeholder="$t('PCSearch.index.646wgb1ni8k0')"
          aria-placeholder=""
          @input="keywordChange"
        ></el-input>
      </div>
      <div class="search-popover" v-show="show">
        <ul class="search-list" v-if="searchList.length > 0">
          <li v-for="(item, i) in searchList" :key="i" @click.stop="go(item.productId)">
            <div class="search-product-name">{{ item.name }}</div>
          </li>
        </ul>
        <div class="search-no" v-else>
          <div>
            <img style="width: 160px; height: 160px; display: block" :src="searchNo" alt="" />
          </div>
          <div>{{ $t('PCSearch.index.empty') }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import searchNo from '@/assets/PC/img/search-no@2x.png';
import { searchPhoneModel } from '@/services/api/product';
export default {
  data() {
    return {
      timer: null,
      searchParams: {
        keyword: '',
        pageSize: 30,
        pageIndex: 1,
        channelId: 100000,
        nation: 'ES'
      },
      searchList: [],
      searchLoading: false,
      searchFinished: false,
      loading: true,
      show: false,
      searchNo
    };
  },
  computed: {
    /**
     * 是否显示搜索列表
     */
    showSearchList() {
      return this.searchParams.keyword && this.searchList.length !== 0;
    },
    /**
     * 是否显示空搜索提示
     */
    showSearchBlank() {
      return this.searchParams.keyword && !this.loading && this.searchList.length === 0;
    }
  },
  watch: {
    /**
     * 监听搜索列表是否展示，设置底层容器是否可以滚动
     */
    showSearchList: function (val) {
      if (val) {
        //展示则不可滚动
        document.body.style.overflow = 'hidden';
      } else {
        //隐藏则可滚动
        document.body.style.overflow = 'auto';
      }
    }
  },
  // components: {
  //   "van-field": Field,
  //   "van-list": List,
  // },
  methods: {
    /**
     * 清空搜索框
     */
    clear() {
      this.searchParams.keyword = '';
    },
    /**
     * 搜索机型
     */
    search() {
      this.loading = true;
      searchPhoneModel(this.searchParams).then(res => {
        if (res.code === '0000') {
          this.loading = false;
          this.show = true;
          this.searchList = this.searchList.concat(res.data.list);
          this.searchLoading = false;
          console.log(this.searchList, '0000this.searchList---');
          if (res.data.nextPage === 0) {
            this.searchFinished = true;
          }
        }
      });
    },
    /**
     * 监听搜索词的变化
     */
    keywordChange(data) {
      let value = data;
      console.log(this.$t('PCSearch.index.646wgb1nj8o0'), value);
      if (this.timer !== null) {
        clearTimeout(this.timer);
        this.timer = null;
      }
      this.searchList = [];
      this.searchFinished = false;
      this.searchLoading = false;
      this.loading = true;
      this.searchParams.pageIndex = 1;
      if (value) {
        this.timer = setTimeout(() => {
          this.search();
        }, 500);
      } else {
        this.show = false;
      }
    },
    /**
     * 搜索列表上拉加载
     */
    onLoadSearch() {
      console.log(this.$t('PCSearch.index.646wgb1nji80'));
      if (!this.searchFinished) {
        this.searchLoading = true;
        this.searchParams.pageIndex++;
        this.search();
      }
    },

    /**
     * 跳转至设备属性页面
     * @param id
     */
    go(id) {
      //清空搜索词，使返回时能不显示搜索结果弹窗
      this.searchParams.keyword = '';
      this.searchList = [];
      const qrcode = this.$route.query.qrCode
      setTimeout(() => {
        let query = { id, qrcode };
        this.$router.push({
          name: 'Property',
          query: query
        });
      }, 100);
    },

    // 跳转至添加新机型页面
    goAddModel() {
      this.$router.push({
        name: 'newModel'
      });
      this.clear();
    }
  }
};
</script>

<style scoped lang="less">
.pc_search {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  .search-main {
    width: 320px;
    position: relative;
    // margin-top: 8px;
    .search-input {
      position: relative;
    }
    /deep/ .el-input__prefix {
      color: #b2b2b2;
    }
    /deep/ .el-input__inner{
      color: #252629;
    }
    /deep/ .el-input__inner {
      border-color: #e0e0e0;
      &:focus {
        border-color: #ff8a14;
      }
      &::placeholder {
        color: #b2b2b2;
      }
    }

    /deep/.search-popover{
      top: 48px;
    }
    .search-popover {
      z-index: 1;
      position: absolute;
      overflow-y: scroll;
      width: 320px;
      height: 244px;
      border-radius: 4px;
      background-color: #fff;
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    }
    .search-product-name {
      width: 100%;
      height: 40px;
      line-height: 40px;
      padding-left: 20px;
      font-size: 14px;
      color: #282828;
      cursor: pointer;
      box-sizing: border-box;
    }
    .search-product-name:hover {
      background-color: #fff5eb;
    }
    .search-no {
      //width: 164px;
      margin: 24px 0px 40px;
      font-size: 14px;
      color: #282828;
      white-space: nowrap;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }
  }
}
</style>
